<template>
  <header>
    <label
      class="back"
      v-show="isHamburgerDisplay"
      @click="isHamburgerDisplay = !isHamburgerDisplay"
    ></label>
    <div class="navbar text-white bg-dark">
      <div class="float-left">
        <router-link exact :to="{ name: 'top' }">
          <img
            src="../../static/LECO_logo.png"
            href="TOP画面"
            class="logo"
            alt="レコのロゴ"
          />
        </router-link>
        <!--押下したらトレ一覧画面に遷移する？リンク貼るだけ-->
      </div>

      <div v-if="isAuthenticated" class="nav-link float-right">
        <div class="hamburger-menu float-right">
          <div class="hamburger-menu-icon">
            <font-awesome-icon
              size="lg"
              icon="bars"
              @click="isHamburgerDisplay = !isHamburgerDisplay"
            />
          </div>
          <transition>
            <nav class="hamburgerMenu" v-show="isHamburgerDisplay">
              <label
                class="hamburger-menu-close"
                @click="isHamburgerDisplay = !isHamburgerDisplay"
                >×</label
              >

              <ul>
                <li>
                  <a :href="manualUrl" target="_blank">
                    操作ガイド
                    <font-awesome-icon icon="arrow-up-right-from-square"
                  /></a>
                </li>
                <li>
                  <a :href="contactInfo" target="_blank">
                    問い合わせ先
                    <font-awesome-icon icon="arrow-up-right-from-square"
                  /></a>
                </li>
                <li v-if="isCognitoAuth">
                  <router-link
                    class="logout-link"
                    active-class="active"
                    exact
                    :to="{ name: 'password-reset' }"
                    >パスワード変更</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="logout-link"
                    v-on:click.native="logout()"
                    active-class="active"
                    exact
                    :to="{ name: 'login' }"
                    >ログアウト</router-link
                  >
                </li>
              </ul>
            </nav>
          </transition>
        </div>

        <div
          class="profile-link float-right"
          style="cursor: pointer"
          @click="isHamburgerDisplay = !isHamburgerDisplay"
        >
          {{ currentUser.idToken.payload.family_name }}&nbsp;{{
            currentUser.idToken.payload.given_name
          }}
        </div>
      </div>
      <div v-else class="nav-link float-right">
        <router-link class="float-right" :to="{ name: 'login' }">
          ログイン
        </router-link>
        <router-link class="float-right" :to="{ name: 'user-registration' }">
          新規登録
        </router-link>
      </div>

      <div v-if="isAuthenticated" id="tabBox">
        <div id="tabs">
          <router-link :to="{ name: 'training-schedule-all' }">
            <label
              :class="[isActive == 1 ? 'is-active-tab' : '']"
              @click="selectedTab(1)"
            >
              予定を見る
            </label>
          </router-link>
          <router-link :to="{ name: 'star-list' }">
            <label
              :class="[isActive == 2 ? 'is-active-tab' : 'disable-tab']"
              @click="selectedTab(2)"
            >
              参加希望を登録する
            </label>
          </router-link>
          <router-link :to="{ name: 'wish-list' }">
            <label
              :class="[isActive == 3 ? 'is-active-tab' : 'disable-tab']"
              @click="selectedTab(3)"
            >
              希望者を見る
            </label>
          </router-link>
          <router-link :to="{ name: 'training-plan-registration' }">
            <label
              :class="[isActive == 4 ? 'is-active-tab' : 'disable-tab']"
              @click="selectedTab(4)"
            >
              トレーニングを登録する
            </label>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { MANUAL_URL, CONTACT_INFO } from "@/common/config";
import cognito from "@/cognito";
import { PURGE_AUTH } from "@/store/mutations.type";

// FontAwesome Setup
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faArrowUpRightFromSquare
} from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
library.add(faBars, faArrowUpRightFromSquare);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

export default {
  name: "LecoHeader",
  data() {
    return {
      isActive: 1,
      logger: this.$store.state.logger,
      isHamburgerDisplay: false,
      manualUrl: "",
      contactInfo: ""
    };
  },
  created() {
    this.manualUrl = MANUAL_URL;
    this.contactInfo = CONTACT_INFO;
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"]),
    isCognitoAuth() {
      return process.env.VUE_APP_AUTH_TYPE === "cognito";
    }
  },
  methods: {
    logout() {
      cognito.logout();
      this.logger.info("cognito logouted");
      this.$store.commit(PURGE_AUTH);
      this.logger.info("vuex info purged");
    },
    selectedTab(selectedTab) {
      this.logger.debug("click tab:" + selectedTab);
      this.isActive = selectedTab;
    }
  }
};
</script>

<style>
/* ハンバーガーメニュー用 */
.hamburgerMenu {
  background: #6c757d;
  height: fit-content;
  z-index: 101;
}

.hamburger-menu-icon {
  z-index: 101;
  margin: 14px 5px;
  cursor: pointer;
}

nav {
  min-width: 210px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  position: absolute;
  right: 0px;
  height: 100%;
  transition: all 0.2s;
}

nav li {
  margin: 10px;
}

.hamburger-menu-close {
  margin: 10px;
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  text-shadow: 0 1px 0 #fff;
}
.back {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0);
  z-index: 100;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* v-tooltip用CSS（ここから） */
/* 本来はヘッダーにこのCSSは不要だがCSSの読み込み順序の関係でここに配置 */
.tooltip {
  display: block !important;
  z-index: 10000;
  padding: 3px;
}
.tooltip .tooltip-inner {
  background: #343a40;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #343a40;
  z-index: 1;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 8px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 3px;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 7px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 3px 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: #343a40;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(#343a40, 0.1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
/* v-tooltip用CSS（ここまで） */

.logo {
  width: 100px;
  margin: 3px 10px;
}

.nav-link {
  position: absolute;
  right: 0;
  top: 0px;
}

.nav-link a,
.profile-link {
  color: #fff !important;
  padding: 14px;
}

.nav-link a:hover {
  color: #de8d12 !important;
}

.is-active-tab {
  background: #ffffff !important;
  color: #6c757d !important;
}

#tabs {
  position: absolute;
  bottom: 0;
  left: 180px;
}

#tabs label {
  display: inline-block;
  line-height: 40px;
  width: 200px;
  text-align: center;
  cursor: pointer;
  background: #6c757d;
  color: #ffffff;
  transition: 0.3s ease-in-out;
  border-radius: 5px 5px 0 0;
  margin-bottom: 0px;
  margin-left: 1px;
}

/* タブレット向け */
@media screen and (max-width: 1240px) {
  #tabBox {
    width: 100%;
  }

  #tabs {
    flex-direction: column;
    position: inherit;
  }

  #tabs label {
    width: 100%;
    border-radius: 0;
    margin-left: 0px;
    border-top: 1px solid #343a40;
  }

  .navbar {
    padding: 0 !important;
  }

  .nav-link {
    padding: 0px !important;
  }
  .nav-link a,
  .profile-link {
    padding: 9px;
  }

  .logo {
    width: 70px;
    margin: 8px;
  }
}

/* スマホ向け */
@media screen and (max-width: 670px) {
  .profile-link {
    display: none;
  }
}
</style>
